(() => {
  'use strict';
  const prefix = 'tag:"Bailey-Cooper Photography" AND ';
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[role="search"]')) return;
    const input = form.querySelector('input[type="search"]');
    if (!input || !input.value.trim()) return;
    const raw = input.value.trim();
    // Use a temporary hidden query so the visitor never sees our brand constraint.
    let query = form.querySelector('[data-bcp-query]');
    if (!query) {
      query = document.createElement('input');
      query.type = 'hidden'; query.name = 'q'; query.dataset.bcpQuery = '';
      form.append(query);
    }
    query.value = raw.startsWith(prefix) ? raw : prefix + '(' + raw + ')';
    input.removeAttribute('name');
    let type = form.querySelector('input[name="type"]');
    if (!type) { type = document.createElement('input'); type.type = 'hidden'; type.name = 'type'; form.append(type); }
    type.value = 'product';
  }, true);
})();
